import { SelectionControl } from './SelectionControl';
import MuiRadio, { type RadioProps as MuiRadioProps } from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';

import { RadioButtonCheckedDisabledIcon, RadioButtonCheckedIcon, RadioButtonDisabledIcon, RadioButtonIcon } from '../icons';

import { colors } from '../styles';

interface RadionButtonProps extends MuiRadioProps {
  label?: string | JSX.Element;
}

const BaseRadioButton = withStyles({
  root: {
    padding: 0,
  },
  colorPrimary: {
    '&$checked': {
      color: colors.success.default,
    },
    '&$disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  },
  checked: {},
  disabled: {},
})((props: MuiRadioProps) => {
  const icon = props.disabled ? <RadioButtonDisabledIcon /> : <RadioButtonIcon />;
  const checkedIcon = props.disabled ? <RadioButtonCheckedDisabledIcon /> : <RadioButtonCheckedIcon />;
  return <MuiRadio color='primary' {...props} icon={icon} checkedIcon={checkedIcon} />;
});

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const RadioButton = (props: RadionButtonProps) => {
  const { label, className, ...otherProps } = props;
  return <SelectionControl className={className} label={label} control={<BaseRadioButton {...otherProps} />} />;
};
